import React from "react";
import { Container, Typography, Link, Box, Grid, Divider, IconButton, Button, useTheme } from "@mui/material";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

function Footer() {
  const theme = useTheme();
  const year = new Date().getFullYear();

  const services = [
    { name: 'Web Development', link: '#services' },
    { name: 'Mobile Apps', link: '#services' },
    { name: 'Digital Marketing', link: '#services' },
    { name: 'UI/UX Design', link: '#services' },
  ];

  const company = [
    { name: 'About', link: '#about' },
    { name: 'Projects', link: '#projects' },
    { name: 'Contact', link: '#contact' },
    { name: 'Testimonials', link: '#' },
  ];

  return (
    <Box 
      component="footer" 
      sx={{
        backgroundColor: '#FAFBFF',
        color: 'text.primary',
        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        pt: 8,
        pb: 4,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography 
              variant="h6" 
              component="div" 
              sx={{ 
                fontWeight: 700, 
                color: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                mb: 2
              }}
            >
              Rak Digital
            </Typography>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              sx={{ mb: 3, maxWidth: '300px' }}
            >
              Building effective digital solutions for small businesses and local small business owners to help them thrive in their communities.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <IconButton 
                href="https://www.linkedin.com/in/eric-rak-tech/" 
                target="_blank" 
                rel="noopener"
                size="small"
                sx={{ 
                  color: '#0077B5',
                  '&:hover': { backgroundColor: 'rgba(0, 119, 181, 0.1)' } 
                }}
              >
                <LinkedInIcon fontSize="small" />
              </IconButton>
              <IconButton 
                href="https://github.com/RakOnTrack" 
                target="_blank" 
                rel="noopener"
                size="small"
                sx={{ 
                  color: '#333',
                  '&:hover': { backgroundColor: 'rgba(51, 51, 51, 0.1)' } 
                }}
              >
                <GitHubIcon fontSize="small" />
              </IconButton>
            </Box>
          </Grid>
          
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Services
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {services.map((service) => (
                <Box component="li" key={service.name} sx={{ mb: 1 }}>
                  <Link 
                    href={service.link}
                    underline="hover"
                    color="text.secondary"
                    sx={{ 
                      fontSize: '0.875rem',
                      transition: 'all 0.2s',
                      '&:hover': { color: 'primary.main' }
                    }}
                  >
                    {service.name}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>
          
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Company
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {company.map((item) => (
                <Box component="li" key={item.name} sx={{ mb: 1 }}>
                  <Link 
                    href={item.link}
                    underline="hover"
                    color="text.secondary"
                    sx={{ 
                      fontSize: '0.875rem',
                      transition: 'all 0.2s',
                      '&:hover': { color: 'primary.main' }
                    }}
                  >
                    {item.name}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Get in Touch
            </Typography>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              sx={{ mb: 2 }}
            >
              Have a small business that needs a digital boost? Let's discuss how I can help you connect with more customers and streamline your operations.
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => {
                document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
              }}
              sx={{ 
                borderRadius: '30px',
                fontWeight: 600,
              }}
            >
              Contact Me
            </Button>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4 }} />
        
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'center', sm: 'center' },
          gap: 2
        }}>
          <Typography variant="body2" color="text.secondary">
            &copy; {year} Rak Digital. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link 
              href="#" 
              color="text.secondary"
              underline="hover"
              sx={{ fontSize: '0.75rem' }}
            >
              Privacy Policy
            </Link>
            <Link 
              href="#" 
              color="text.secondary"
              underline="hover"
              sx={{ fontSize: '0.75rem' }}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
